export const countriesConstants = {
    COUNTRIES_START: 'countries:start',
    COUNTRIES_STOP: 'countries:stop',
    COUNTRIES_COUNTRIES: 'countries:countries',
    COUNTRIES_CLEAR: 'countries:clear',
};
